// schwabdata-20261104: owner-locked Schwab reads for Portfolio / Journal.
// One hook for every /stk/<op> GET (portfolio, fills, accounts); the account is
// the badge's selection (index only - hashes never leave the relay).
import { useState, useEffect, useCallback } from 'react'
import { BASE, KEY, OWNER } from '../components/SchwabAccountBadge'

export const stkAcctIdx = () => parseInt(localStorage.getItem(KEY) || '0', 10) || 0

export function useSchwab(op, { enabled = true, days = 1 } = {}) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const refresh = useCallback(async () => {
    const owner = localStorage.getItem(OWNER) || ''
    if (!enabled || !owner) { setData(null); setError(null); return }
    setLoading(true)
    try {
      const r = await fetch(`${BASE}/stk/${op}?idx=${stkAcctIdx()}&days=${days}`, { headers: { 'X-Owner-Key': owner } })
      if (!r.ok) throw new Error(r.status === 404 ? 'not live yet' : `HTTP ${r.status}`)
      setData(await r.json()); setError(null)
    } catch (e) { setError(e.message || String(e)) } finally { setLoading(false) }
  }, [op, enabled, days])
  useEffect(() => { refresh() }, [refresh])
  return { data, loading, error, refresh }
}

// Schwab TRADE transactions -> the Hyperliquid fill shape WalletHistoryPanel
// and Portfolio activity already render. Schwab gives no realized P&L per fill.
export const stkFillsAsHl = (rows) => (Array.isArray(rows) ? rows : []).map(f => {
  const q = Number(f.qty) || 0
  return { tid: `${f.id}-${f.sym}`, time: Date.parse(f.time) || 0, symbol: f.sym, side: q >= 0 ? 'buy' : 'sell',
    qty: Math.abs(q), price: f.price, notional: Math.abs(Number(f.cost) || 0), fee: Number(f.fee) || 0,
    dir: `${f.effect === 'CLOSING' ? 'Close' : 'Open'} ${q >= 0 ? 'Long' : 'Short'}`, closedPnl: 0 }
}).sort((a, b) => b.time - a.time)
